module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/lock-screen/lock-screen.component.css
// module id = ./src/app/shared/components/lock-screen/lock-screen.component.css
// module chunks = main